module.exports = __webpack_public_path__ + "static/media/1.0a863d89.png";